<template>
  <div class="MyOrder">
    <div class="add">
      <el-button type="primary" plain @click="handleToBarter()">
        新增换货申请
      </el-button>
    </div>
    <ul class="tagList">
      <li
        :class="{ selected: form_head_uuid === item.form_head_uuid }"
        v-for="(item, index) in tagList"
        :key="'tag' + index"
        @click="changeIndex(item.form_head_uuid)"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="orderBox" v-if="orderList && orderList.length > 0">
      <div class="orderTableHeader">
        <span>商品</span>
        <span>换货数量</span>
      </div>
      <ul class="orderList">
        <li v-for="item in orderList" :key="'order' + item.id">
          <div class="orderHeader">
            <span class="orderTime">{{ item.daivuh1o9jlphcxp }}</span>
            <span class="orderId">
              {{ '换货单编号：' + item['3pp6dg9j4ex79ook'] }}
            </span>
          </div>
          <div
            class="orderDetail"
            v-for="(order, idx) in item.children"
            :key="idx"
          >
            <img
              :src="
                order.bal0wugwwskobosz && order.bal0wugwwskobosz.length > 0
                  ? order.bal0wugwwskobosz[0].url
                  : ''
              "
              alt="商品图片"
            />
            <div class="goodsName">
              <p
                v-if="
                  order.tlztdbj3bxchs5vi && order.tlztdbj3bxchs5vi.length > 0
                "
              >
                {{ order.tlztdbj3bxchs5vi[0].value }}
              </p>
            </div>
            <span class="num">{{ order['me6d75ufdtk3amaq'] || 0 }}</span>
            <span class="status" v-if="idx === 0">
              <img
                src="@/assets/img/shz.svg"
                alt=""
                v-if="
                  item.qpfsvknudb8gbzee ===
                  'ead617a0-f13a-49c6-b7d0-c18355f330c0'
                "
              />
              <img
                src="@/assets/img/success.svg"
                alt=""
                v-else-if="
                  item.qpfsvknudb8gbzee ===
                  'f5d63c14-f8ee-4279-81f8-4d63ae88df9c'
                "
              />
              <img
                src="@/assets/img/fail.svg"
                alt=""
                v-else-if="
                  item.qpfsvknudb8gbzee ===
                  '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
                "
              />
              <img
                src="@/assets/img/ywc.svg"
                alt=""
                v-else-if="
                  item.qpfsvknudb8gbzee ===
                  'fa090b14-a3ee-4eac-89c2-32cfc12c5619'
                "
              />
            </span>
          </div>
          <div class="orderfooter">
            <!-- <div>{{ item.qpfsvknudb8gbzee }}</div> -->
            <!-- {{ item.indtkil4tvvff0ie }} -->
            <!-- 换货方式 自行寄回 + 物流单号 不为空 + 换货状态 审批成功 待寄回 -->
            <el-button
              type="primary"
              v-if="
                item.qpfsvknudb8gbzee ===
                  'dcc22cc0-d69b-4dbe-ab01-e0680a7391dc' &&
                item.indtkil4tvvff0ie ===
                  '4baade9e-2402-4ffd-9d57-74c1abc800cc' &&
                item['3u7sabpxxpxioiqz']
              "
              @click="confirmedMailReturn(item)"
            >
              确认邮寄退货
            </el-button>
            <!-- <el-button type="primary"> 确认送达 </el-button> -->
            <el-button
              type="primary"
              v-if="
                item.qpfsvknudb8gbzee === '67eb6174-0c8f-4e11-845c-4981b6f8d2a4'
              "
              @click="resubmit(item)"
            >
              重新提交
            </el-button>
          </div>
        </li>
      </ul>
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="page"
          :page-sizes="[10, 20, 40, 80]"
          :page-size="limit"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <p class="emptyTips" v-else>
      <img src="../../assets/img/order.svg" alt="" />
    </p>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Popup from "../../components/Popup";
import { otherSystemGetLoginToMeUrl } from "@/util/util";
import { online, children, execButton } from "@/api/platform";
export default {
  name: "MyOrder",
  components: {
    Popup,
  },
  computed: {
    ...mapState(["clientToken"]),
  },
  data () {
    return {
      tagList: [
        {
          name: "全部",
          form_head_uuid: "01941b9eae0811ee879f0242321230b4",
        },
        { name: "审核中", form_head_uuid: "976291baa51a41559bfc6d41fa128aa2" },
        {
          name: "审核成功",
          form_head_uuid: "b9f9e6e04e524515b85a530b38b7c1e2",
        },
        {
          name: "审核失败",
          form_head_uuid: "5a7dfb24853a4408afc21d7b68e9f9fa",
        },
        {
          name: "已邮寄",
          form_head_uuid: "bd4e90b15bbd494daf30148ea17f28bf",
        },
        {
          name: "已验收",
          form_head_uuid: "97dba52f85eb40989c6b633c8163a092",
        },
        {
          name: "配送中",
          form_head_uuid: "4d7d1203f6a54ff99d186122981b2756",
        },
        {
          name: "确认收货",
          form_head_uuid: "0eb2e755c1e9492a9a6c5fd235029629",
        },
      ],
      form_head_uuid: "01941b9eae0811ee879f0242321230b4",
      orderList: [],
      popupShow: false,
      curOrderId: "",
      curCommentGoodsId: "",
      curCommentGoodsDetailId: "",
      curStar: 0,
      hasClickStar: false,
      comment: "",
      //分页
      page: 1,
      total: 0,
      limit: 20,
      // 退货方式
      returnMethod: [
        { label: '上门取件', value: '99152472-0949-4a28-89fc-61e8ddffaac3' },
        { label: '自行寄回', value: '4baade9e-2402-4ffd-9d57-74c1abc800cc' }
      ],
      merchandiseOrder: [],
      dialogVisible: false,
      form: {},
    };
  },

  methods: {
    // 获取订单列表
    async getOrderList () {
      const { form_head_uuid, page, limit } = this;
      const { meta, result } = await online({
        form_head_uuid,
        page,
        limit,
        keyword: "",
        select_option: "",
      });
      let list = await Promise.all(
        result.map(async (el) => ({
          ...el,
          children: await this.children(el.id),
        }))
      );
      this.orderList = list;
      this.total = meta.total;
    },
    // 获取子表数据
    async children (record_id) {
      const { form_head_uuid } = this;
      const { result } = await children({
        page: 1,
        limit: 100,
        field_uuid: "01942404ae0811ee8b7d0242321230b4",
        form_head_uuid,
        record_id,
      });
      return result;
    },
    // 切换页数
    handleCurrentChange (page) {
      this.page = page;
      this.getOrderList();
    },
    handleSizeChange (limit) {
      this.page = 1;
      this.limit = limit;
      this.getOrderList();
    },
    changeIndex (form_head_uuid) {
      this.page = 1;
      this.form_head_uuid = form_head_uuid;
      this.getOrderList();
    },
    navTo (route) {
      this.$router.push(route);
    },
    // 跳转到换货申请
    handleToBarter () {
      otherSystemGetLoginToMeUrl('90289196e59411ee8f230242ac150003', 'UvlkMQnzvibBsepj')
    },
    // 确认邮寄退货
    async confirmedMailReturn ({ id }) {
      await execButton({
        button_uuid: "4e515e73-30e2-4a5f-8d45-bf5b738200f6",
        form_head_uuid: "01941b9eae0811ee879f0242321230b4",
        id,
        type: 2,
      })
      this.$notify({
        title: "提示",
        message: "确认邮寄退货成功",
        type: "success",
      });
      this.page = 1;
      setTimeout(() => {
        this.getOrderList();
      }, 2000);
    },
    // 重新提交
    resubmit ({ id }) {
      this.$confirm("确认要重新发起审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          await execButton({
            button_uuid: "1b34a932-656e-4604-85dc-3614f20a2a42",
            form_head_uuid: "01941b9eae0811ee879f0242321230b4",
            id,
            type: 2,
          });
          this.$notify({
            title: "提示",
            message: "重新发起审核成功",
            type: "success",
          });
          this.page = 1;
          setTimeout(() => {
            this.getOrderList();
          }, 2000);
        })
        .catch(() => { });
    }
  },

  mounted () {
    this.getOrderList();
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';
.MyOrder {
  .tagList {
    li {
      text-align: center;
      display: inline-block;
      font-weight: 550;
      font-size: 18px;
      border-bottom: 2px solid @borderColor;
      cursor: pointer;
      padding: 10px 20px;
      position: relative;
      &:after {
        top: 12px;
        right: 0;
        position: absolute;
        content: '';
        width: 1px;
        height: 15px;
        background-color: @borderColor;
      }
      &:last-child {
        &:after {
          display: none;
        }
      }
    }
    .selected {
      color: @thirdColor;
      border-bottom: 2px solid @thirdColor;
    }
  }
  .orderBox {
    width: 100%;
    margin-top: 20px;
    .orderTableHeader {
      width: 100%;
      height: 40px;
      background-color: #f5f5f5;
      border: 1px solid @borderColor;
      color: @fontDefaultColor;
      font-size: 14px;
      line-height: 40px;
      display: flex;
      justify-content: flex-start;
      span {
        display: inline-block;
        width: 150px;
        line-height: 40px;
        text-align: center;
        &:first-child {
          width: 500px;
        }
      }
    }
    .orderList {
      width: 100%;
      li {
        border: 1px solid @borderColor;
        font-size: 13px;
        margin-top: 10px;
        .orderHeader {
          background-color: #f1f1f1;
          height: 40px;
          line-height: 40px;
          padding: 0 5px;
          .orderTime {
            font-weight: 600;
          }
          .orderId,
          .state {
            margin-left: 10px;
          }
          .deleteBtn {
            float: right;
            cursor: pointer;
            i {
            }
          }
        }
        .orderDetail {
          width: 100%;
          padding: 10px;
          position: relative;
          overflow: hidden;
          display: flex;
          justify-content: flex-start;
          img {
            width: 84px;
            height: 84px;
            display: inline-block;
          }
          .goodsName {
            display: inline-block;
            margin-left: 5px;
            width: 400px;
            vertical-align: top;
            p {
              cursor: pointer;
              line-height: 20px;
              &:hover {
                text-decoration: underline;
              }
            }
            span {
              color: @fontDefaultColor;
              display: block;
              margin-top: 10px;
            }
          }
          .unitPrice,
          .num,
          .amount,
          .hasComment {
            display: inline-block;
            vertical-align: top;
            width: 150px;
            height: 85px;
            line-height: 85px;
            text-align: center;
          }
          .status {
            position: absolute;
            right: 10px;
            img {
              width: 70px;
              opacity: 0.9;
            }
          }
          button {
            position: absolute;
            right: 90px;
            top: 50%;
            transform: translate(0, -50%);
            width: 70px;
            height: 30px;
            border-radius: 3px;
            background-color: @thirdColor;
            color: white;
            border: none;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: flex-end;
      margin: 20px 0 0;
    }
  }
  .popupContent {
    padding: 10px;
    .scoreBox {
      width: 100%;
      height: 50px;
      position: relative;
      line-height: 50px;
      text-align: left;
      .tips {
        font-size: 15px;
        vertical-align: middle;
        display: inline-block;
      }
      i {
        cursor: pointer;
        vertical-align: middle;
        display: inline-block;
        font-size: 25px;
        margin-right: 5px;
        -webkit-text-stroke: 1px #f9bd4f;
      }
    }
    textarea {
      width: 400px;
      height: 80px;
      padding: 5px;
      border: 1px solid @borderColor;
      display: block;
      margin-top: 10px;
    }
    button {
      display: block;
      margin: 10px auto;
      width: 70px;
      height: 30px;
      border-radius: 3px;
      background-color: #313541;
      color: white;
      border: none;
    }
  }
}
.emptyTips {
  text-align: center;
  margin: 200px auto;
}
</style>


// WEBPACK FOOTER //
// src/pages/client/Barter.vue